angular.module('admin.directives')

  .directive('stream', ['Dictionary', '$interval', 'HomeActivity', 'UtilService', 'ActivityDictionary', function(Dictionary, $interval, HomeActivity, utils, ActivityDictionary, undefined){
    return {
      restrict: 'E',
      controllerAs: 'streamCtrl',
      bindToController: {
        autoRefresh: '@',
        agentId: '@',
        homeId: '@',
        limit: '@',
        userId: '@',
        streamStyle: '@',
        type: '@'
      },
      scope: {},
      templateUrl: function(el, attrs){
        if(attrs.type === 'client')
          return '/admin/templates/partials/stream-client.html';
        else if(attrs.type === 'agent')
          return '/admin/templates/partials/stream-agent.html';

        return '/admin/templates/partials/stream-all.html';
      },

      controller: ['$scope', '$interval', function($scope, $interval){
        var lastTimeRefreshed;
        var ctrl = this;
        var where = {};
        var include;
        var limit;
        var refresher = undefined;
        var activityDictionary = new ActivityDictionary();

        ctrl.loadingFirstBatch = true;

        ctrl.activity = [];

        if(ctrl.type === 'agent')
          where = {
            agentId: ctrl.agentId,
            event: ["open", "spam", "soft_bounce", "hard_bounce", "cma-notify-client", "cma-request", "view", "reject", "viewedRefiDetails", "viewed-market-panel", "viewed-home-insurance-panel"]
          };
        else if(ctrl.type === 'client')
          where = {userId: ctrl.userId, homeId: ctrl.homeId};

        if(ctrl.type === 'admin')
          include = ['user', 'agent'];

        ctrl.refresh = function(){
          if(!where) throw new Error('Where not defined on stream');

          if(lastTimeRefreshed)
            where.created = {gte: lastTimeRefreshed};

          limit = ctrl.limit || null;

          HomeActivity.getActivity(where, include, limit)
            .then(function(activity){
              activity = activity || [];

              if(ctrl.type === 'agent')
                ctrl.activity = ctrl.lookupActivity('sortAndGroupEvents', activity).concat(ctrl.activity);
              else
                ctrl.activity = activity.concat(ctrl.activity);

              lastTimeRefreshed = moment().toDate();
              ctrl.loadingFirstBatch = false;
            })
            .catch(function(err){
              ctrl.errorMsg = 'There was an error loading activity';
              utils.trackException('Get Activity', err);
            });
        };

        ctrl.lookupActivity = function(prop,stream){
          stream = stream || ctrl.activity;
          return activityDictionary[prop](stream);
        };

        function startRefresher(){
          if(refresher) return;

          refresher = $interval(function(){
            ctrl.refresh();
          }, 1000 * 60);
        };

        function stopRefresher(){
          if(refresher)
            $interval.cancel(refresher);

          refresher = undefined;
        };

        $scope.$on('$destroy', stopRefresher);

        if(ctrl.autoRefresh === 'true')
          startRefresher();

        ctrl.refresh();
      }]
    }

  }]);
